import type { FC } from 'react';
import {
  WkFooter,
  FooterContainer,
  FooterNavigation,
  FooterItem,
  FooterNavigationLink,
  FooterCopyright,
} from '@wk/components-react16';

import { HUB_API_URL } from '@/config/env';

import './styles.css';

interface FooterProps {
  isReleaseNotesAvailable: boolean;
}

const joinUrl = (baseUrl: string, path: string) => {
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};

const Footer: FC<FooterProps> = ({ isReleaseNotesAvailable }) => {
  const hubBaseUrl = HUB_API_URL;

  return (
    <WkFooter mode="workflow">
      <FooterContainer mode="workflow">
        <FooterNavigation mode="workflow">
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href={joinUrl(hubBaseUrl, '/')}
            >
              Documentation{' '}
            </FooterNavigationLink>
          </FooterItem>
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href="https://wkengineering.atlassian.net.mcas.ms/browse/PCOM?McasTsid=20596&McasCtx=4"
            >
              Support{' '}
            </FooterNavigationLink>
          </FooterItem>
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href={joinUrl(hubBaseUrl, '/governance/orr/overview/')}
            >
              Guides
            </FooterNavigationLink>
          </FooterItem>
          <FooterItem>
            <FooterNavigationLink
              target="_blank"
              href={joinUrl(hubBaseUrl, '/governance/orr/orr-ado-extension/')}
            >
              ADO Extension
            </FooterNavigationLink>
          </FooterItem>
          {isReleaseNotesAvailable ? (
            <FooterItem>
              <FooterNavigationLink href={`${import.meta.env.BASE_URL}newsletter`}>
                Newsletter
              </FooterNavigationLink>
            </FooterItem>
          ) : null}
        </FooterNavigation>
        <FooterCopyright
          mode="workflow"
          template="GBS Architecture & Engineering Services |  %year% %copy% Wolters Kluwer N.V. All rights reserved"
        ></FooterCopyright>
      </FooterContainer>
    </WkFooter>
  );
};

export default Footer;
